/* eslint-disable import/prefer-default-export */
import { NestApiType, nestCall } from '@/composables/nestApi';
import { GleapChecklistEvent } from '@/types/enums';

interface TrackingConsentObjectives {
  nl_implies_tracking: boolean;
  display_forms: { compliant: boolean };
}

/**
 * Gleap checklist events of the tracking consent objectives the active shop
 * has achieved. Gleap only accepts achievements: an objective not met sends nothing.
 */
export const getAchievedTrackingConsentChecklistEvents = async (): Promise<GleapChecklistEvent[]> => {
  const result = await nestCall('get', NestApiType.CLIENT_API, '/tracking-consent/objectives');
  if (!result || (result as any).error) {
    return [];
  }

  const objectives = result as TrackingConsentObjectives;
  const events: GleapChecklistEvent[] = [];
  if (objectives.nl_implies_tracking) {
    events.push(GleapChecklistEvent.GLEAP_CHECKLIST_TRACKING_CONSENT_NEWSLETTER_OPTION);
  }
  // A shop without any email form has nothing to bring into line: compliant too.
  if (objectives.display_forms?.compliant) {
    events.push(GleapChecklistEvent.GLEAP_CHECKLIST_TRACKING_CONSENT_DISPLAY_FORMS);
  }
  return events;
};
